exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-change,.v-app,.v-application,body,html{font-size:10pt;font-family:ABCFavorit,system-ui,sans-serif!important}.pagebreak{page-break-after:always;min-height:1px}.one-third-page{height:33.33333%}.certification,.local-description,.usage{font-size:8pt}.signature-title{border-top:1px solid #666}", ""]);

// exports
